import { render, staticRenderFns } from "./DepositReturn.vue?vue&type=template&id=062158b8&scoped=true&"
import script from "./DepositReturn.vue?vue&type=script&lang=js&"
export * from "./DepositReturn.vue?vue&type=script&lang=js&"
import style0 from "./DepositReturn.vue?vue&type=style&index=0&id=062158b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062158b8",
  null
  
)

export default component.exports